<li [ngClass]="{ open: isOpenSection('intro') }">
  <span class="notebook-sidebar-title" (click)="toggleSection('intro')">
    <capra-icon icon="icon-chevron-right"></capra-icon> Intro to Notebooks
  </span>
  <div *ngIf="!isRegisterImportedDatasetEnabled" class="item-text">
    <p>
      Your query results are accessible in Python as pandas DataFrames. You can access them in the variable <code
        >datasets</code
      >
      using the name of the query:
    </p>
    <ul>
      <li>example: <code>datasets["your query name"]</code></li>
    </ul>
    <p>
      <i
        >Note: <code>datasets</code> will update when you run a SQL query. It is best to run queries after you rename
        them so that your Python Notebook has the latest results.</i
      >
    </p>
    <p>
      If you prefer to access your query results in other ways, you can read more about datasets on
      <a [href]="helpDocs.links['https://mode.com/help/articles/notebook/#accessing-query-results']" target="_blank"
        >this Help page</a
      >.
    </p>
  </div>

  <!-- Help section including imported dataset instructions -->
  <div *ngIf="isRegisterImportedDatasetEnabled" class="item-text">
    <p>
      Your query results and reusable Datasets excluding calculated fields are accessible in Python as pandas
      DataFrames. You can access them in the variable <code>datasets</code> using the token, name, or index of the query
      or Dataset:
    </p>
    <ul>
      <li>
        example: <code>datasets["6763b688fb54"]</code> or <code>datasets[“your query or Dataset name”]</code> or
        <code>datasets[1]</code>
      </li>
    </ul>
    <p>
      <i
        >Note: <code>datasets</code> will update when you run a SQL query and Dataset. It is best to run queries or
        Datasets after you rename them so that your Python Notebook has the latest results. Learn more about accessing
        your queries and Datasets
        <a [href]="helpDocs.links['https://mode.com/help/articles/notebook/#accessing-query-results']" target="_blank"
          >here</a
        >.</i
      >
    </p>
    <p>
      The Python Notebook will process Python code when input cells are run, and return output accordingly. In order to
      use any of the Python packages supported, you must first import the package to the Notebook (example:
      <code>import numpy as np</code>).
    </p>
    <p>
      <a (click)="goToSupportedLibraries.emit()">Supported packages</a> are referenced in this side panel, along with
      helpful notebook <a (click)="goToKeyboardShortcuts.emit()">keyboard shortcuts</a> and links to other resources,
      including various <a href="https://mode.com/example-gallery/" target="_blank">recipes</a> for analysis that will
      help you get started or accelerate your analysis for some common use cases.
    </p>
  </div>
</li>
